import React from 'react'
import update from 'immutability-helper'

import { lease } from '../../core/controllers/Lease';
import { tenant } from '../../core/controllers/Tenant';
import { dropZone } from '../../core/utilities/DropZoneHandler';
import { property } from '../../core/controllers/Property';
import { documents } from '../../core/controllers/Documents';
import { modal } from '../../core/utilities/modal'
import moment from 'moment';

import SalesReportedList from '../Leases/SalesReportedList'
import ActionCenterCard from '../../helpers/Cards/ActionCenter';
import { ActionCenterEntry } from '../../helpers/Cards/ActionCenter';

// #  TODO move this to seperate component
const Attachment = ({attachment}) => {
    return (
        <attachment key={attachment.id}>
            <div class={attachment.content_type == 'pdf' ? "col-lg-12 col-md-12 col-sm-12 col-xs-12 col-xs-12" : "col-lg-3 col-md-3 col-sm-4 col-xs-6 col-xs-6"}>
                <a href={attachment.url} target="_blank">
                    { attachment.content_type == 'pdf' ? (
                        <object width="100%" height="500" data={attachment.url} type="application/pdf"></object>
                    ) : (
                        <img src={attachment.url} width="100px" height="100px" />
                    )}
                </a>
            </div>
        </attachment>
    );
};

export default class LeaseTenantView extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            attachments: null,
            agreement: null,
            leaseData: {
                contract_amount: 0,
                payment_recurrence_method: 'month',
                term_length: 0,
                title: '',
                sales_percentage: 0
            },
            lease: {
                property_id: 0,
            },
            unitName: '',
            propertyName: '',
            tenantName: '',
            onLease: true,
            signature: null,
            overviewActive: 'active',
            reportSalesActive: '',
        };
        this.index = 0;
    }

    componentDidMount() {
        var self = this;
        var propertyID = 0;
        var leaseID = 0;

        lease.getTenantData(function(tenantData){
            leaseID = tenantData.data.contract_id;
            if (leaseID == null) {
                self.setState({
                    onLease: false
                });
            } else {
                lease.setLeaseID(leaseID);
                lease.getLease(function(lease) {
                    var leaseData = lease.data[0].data;
                    leaseData.contract_amount = leaseData.contract_amount != null ? self.formatAmount((leaseData.contract_amount).toString()) : 0;
                    leaseData.security_deposit = leaseData.security_deposit != null ? self.formatAmount((leaseData.security_deposit).toString()) : 0;
                    leaseData.pet_deposit = leaseData.pet_deposit != null ? self.formatAmount((leaseData.pet_deposit).toString()) : 0;
                    if(lease.data[0].property){
                        propertyID = lease.data[0].property.property_id
                        property.getProperty(propertyID, function(response) {
                            self.findUnit(response.data.units, response.data.details.contract_id)
                            self.setState({
                                lease: update(self.state.lease, {
                                    property_id: {$set: response.data.details.property_id},
                                }),
                                propertyName: response.data.details.property_name,
                                tenantName: tenantData.data.data.tenant_firstname + " " + tenantData.data.data.tenant_lastname,
                                signature: tenantData.data.signature,
                                leaseData: leaseData,
                                agreement: tenantData.data.agreement
                            });
                        });
                    } else {
                        self.setState({
                            tenantName: tenantData.data.data.tenant_firstname + " " + tenantData.data.data.tenant_lastname,
                            signature: tenantData.data.signature,
                            leaseData: leaseData,
                            agreement: tenantData.data.agreement
                        });
                    }
                });
            }
        });
        dropZone.setup(this, 'leaseagreement', leaseID);
    }

    /**
     * Formats money, if not value, return 0
     * @param {*} e
     */
    formatAmount(value) {
        var money = parseFloat(value);
        if(isNaN(money) || money === 0) {
            money = 0;
        } else {
            money = money / 100;
            money.toLocaleString("en-US", {style:"currency", currency:"USD"});
        }

        return money;
    }

    findUnit(unitArray, contractID) {
        unitArray.map((value, index) => {
            if (value.contract_id == contractID) {
                this.setState({
                    unitName: value.unit_name,
                });
            }
        })
    }

    renderAttachments(attachments) {
        var self = this;
        if (attachments !== null) {
            if(attachments.length > 0) {
                var attachmentsLength = attachments.length
                for (var i = 0; i < attachmentsLength; i++) {
                    if (attachments[i].content_type == "pdf") {
                        var temp = attachments[i]
                        attachments.splice(i, 1);
                        attachments.push(temp)
                    }
                }
                return attachments.map((attachment, index) => (
                    <Attachment key={index} attachment={attachment}/>
                ));
            }
        }
        else return null;
    }

    renderAgreement(agreement) {
        var self = this;
        if (agreement !== null) {
            return <Attachment attachment={agreement}/>
        }
        else return null;
    }

    checkLeaseStatus(leaseExpirationDate) {
        var monthDiff = leaseExpirationDate.diff(moment(), "months")
        var dayDiff = leaseExpirationDate.diff(moment(), "days") + 1

        if (monthDiff > 1) {
            return "Expiring in " + monthDiff + " months!"
        } else if (monthDiff == 1) {
            return "Expiring in 1 month!"
        } else {
            if(dayDiff > 1) {
                return "Expiring in " + dayDiff + " days!"
            } else if (dayDiff == 1) {
                return "Expiring in 1 day!"
            } else {
                return "Expired!"
            }
        }
    }

    onRequestMoveOut(){
        lease.requestMoveOut(function(response){
            modal.showInfo("An email to request move out has been sent to your Property Manager!", "success", "top", "center");
        });
    }

    onRequestRenewal(){
        lease.requestRenewal(function(response){
            modal.showInfo("An email to request renewal has been sent to your Property Manager!", "success", "top", "center");
        });
    }

    sendSignatureEmail() {
        tenant.getSignatureEmail(function(response) {
            modal.showInfo("Please follow the instructions emailed to you.", "success", "top", "center");
        });
    }

    handleTabChange(type) {
        if(type == 'overview') {
            this.setState({
                overviewActive: 'active',
                reportSalesActive: '',
            });
        } else if (type == 'report_sales') {
            this.setState({
                overviewActive: '',
                reportSalesActive: 'active',
            });
        }
    }

    render(){
        const agreement = this.renderAgreement(this.state.agreement);
        const leaseName = this.state.leaseData.title;
        const termLength = this.state.leaseData.term_length;
        const monthlyAmount = this.state.leaseData.contract_amount;
        const dueDay = this.state.leaseData.rent_due_day;
        const securityDeposit = this.state.leaseData.security_deposit;
        const petDeposit = this.state.leaseData.pet_deposit;
        const propertyName = this.state.propertyName;
        const unitName = this.state.unitName;
        const moveOutDate = this.state.leaseData.contract_expiration_date;
        const moveInDate = this.state.leaseData.effective_date;
        const tenantName = this.state.tenantName;
        const leaseStatus = this.checkLeaseStatus(moment(this.state.leaseData.contract_expiration_date))
        const onLease = this.state.onLease;
        const signature = this.state.signature;
        const overviewActive = this.state.overviewActive;
        const reportSalesActive = this.state.reportSalesActive;
        const doesReportSales = this.state.leaseData.sales_percentage;

        var leaseSigned = "N/A";
        var disableRequestSig = true;
        var requestSigButtonText = "Request Sign Lease";
        if (signature != null) {
            if (signature.length > 0) {
                signature.map(function(item) {
                    if (item.deleted_at == null) {
                        if (item.pending == 1) {
                            leaseSigned = "Not Signed";
                            disableRequestSig = false;
                            requestSigButtonText = "Re-request Sign Lease";
                        } else {
                            if (item.date_signed != null) {
                                leaseSigned = "Signed";
                                disableRequestSig = true;
                                requestSigButtonText = "Request Sign Lease";
                            }
                        }
                    }
                })
            }
        }

        if (!onLease) {
            return (
                <div>
                    <div class="content">
                        <div class="row">
                            <div class="main-page-header-row col-md-12">
                                <div style={{textAlign: "center", marginTop: "30px"}}>
                                    <div class="row">
                                        <span class="main-page-header-title">Sorry, looks like you have no active lease</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-12" style={{backgroundImage: "url('/assets/img/lease.png')", backgroundRepeat: 'no-repeat', backgroundPosition: 'bottom', backgroundSize: '30%', minHeight: '500px'}}></div>
                </div>
            )
        } else {
            return (
                <div>
                    { doesReportSales != null && doesReportSales > 0 && (
                    <div class="row">
                        <div class="col-md-12">
                            <div class="col-md-3 col-md-offset-3 col-sm-6 col-xs-12">
                                <h4 class={"cross-tab-select " + overviewActive} onClick={this.handleTabChange.bind(this, 'overview')}>OVERVIEW</h4>
                            </div>
                            <div class="col-md-3 col-sm-6 col-xs-12">
                                <h4 class={"cross-tab-select " + reportSalesActive} onClick={this.handleTabChange.bind(this, 'report_sales')}>REPORT SALES</h4>
                            </div>
                        </div>
                    </div>
                    )}
                    <br/>
                    {overviewActive == 'active' && (
                    <div>
                    <div class="sub-page-header-row col-md-11">
                        <div class="row">
                            <span class="sub-page-header-title">Lease Information</span>
                        </div>
                    </div>
                    <div class="col-md-8 col-sm-12 col-xs-12">
                        <div class="card">
                            <div class="header">
                                <h4 class="title">Lease</h4>
                                <p class="category"></p>
                            </div>
                            <div class="content">
                                <form>
                                    <div class="row">
                                        <div class="col-md-5 col-sm-6 col-xs-12">
                                            <div class="form-group">
                                                <label>Name</label>
                                                <input type="text" class="form-control tenant-info" value={leaseName} placeholder="N/A" readOnly/>
                                            </div>
                                        </div>
                                        <div class="col-md-5 col-sm-6 col-xs-12 col-md-offset-1">
                                            <label>Amount</label>
                                            <div class="form-group has-feedback">
                                                <input type="text" class="form-control tenant-info input-group-dollar-addon" value={monthlyAmount} placeholder="N/A" readOnly/>
                                                <i class="form-control-feedback fa fa-dollar" style={{left:"3px"}}></i>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-md-5 col-sm-6 col-xs-12">
                                            <div class="form-group">
                                                <label>Payment Occurance</label>
                                                <div class="clearfix"></div>
                                                <input type="text" class="form-control tenant-info" value={'Monthly'} readOnly/>
                                            </div>
                                        </div>
                                        <div class="col-md-5 col-sm-6 col-xs-12 col-md-offset-1">
                                            <div class="form-group">
                                                <label>Due Day</label>
                                                <input type="text" class="form-control tenant-info" value={dueDay} placeholder="N/A" readOnly/>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-md-5 col-sm-6 col-xs-12">
                                            <div class="form-group">
                                                <label>Lease Length</label>
                                                <input type="text" class="form-control tenant-info" value={termLength} placeholder="N/A" readOnly/>
                                            </div>
                                        </div>
                                        <div class="col-md-5 col-sm-6 col-xs-12 col-md-offset-1">
                                            <label>Security Deposit</label>
                                            <div class="form-group has-feedback">
                                                <input type="text" class="form-control tenant-info input-group-dollar-addon" value={securityDeposit} placeholder="N/A" readOnly/>
                                                <i class="form-control-feedback fa fa-dollar" style={{left:"3px"}}></i>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-md-5 col-sm-6 col-xs-12">
                                            <div class="form-group">
                                                <label>Property</label>
                                                <input type="text" class="form-control tenant-info" value={propertyName} placeholder="N/A" readOnly/>
                                            </div>
                                        </div>
                                        <div class="col-md-5 col-sm-6 col-xs-12 col-md-offset-1">
                                            <label>Pet Deposit</label>
                                            <div class="form-group has-feedback">
                                                <input type="text" class="form-control tenant-info input-group-dollar-addon" value={petDeposit} placeholder="N/A" readOnly/>
                                                <i class="form-control-feedback fa fa-dollar" style={{left:"3px"}}></i>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row">
                                    <div class="col-md-5 col-sm-6 col-xs-12">
                                            <div class="form-group">
                                                <label>Unit</label>
                                                <input type="text" class="form-control tenant-info" value={unitName} placeholder="N/A" readOnly/>
                                            </div>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                        <div class="card">
                            <div class="header">
                                <h4 class="card-icon-title"><span class="card-box-icon blue-card-icon-circle"><i class="icon-apartment-outline"></i></span> Tenant</h4>
                                <p class="category"></p>
                            </div>
                            <div class="content">
                                <form>
                                    <div class="row">
                                        <div class="col-md-5 col-sm-6 col-xs-12">
                                            <div class="form-group">
                                                <label>Move In Date</label>
                                                <input type="text" class="form-control tenant-info" value={moment(moveInDate).format("MMM DD YYYY")} placeholder="N/A" readOnly/>
                                            </div>
                                        </div>
                                        <div class="col-md-5 col-sm-6 col-xs-12 col-md-offset-1">
                                            <div class="form-group">
                                                <label>Move Out Date</label>
                                                <input type="text" class="form-control tenant-info" value={moment(moveOutDate).format("MMM DD YYYY")} placeholder="N/A" readOnly/>
                                            </div>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-4 col-sm-12 col-xs-12">
                        <div class="card">
                            <div class="row">
                                <div class="col-md-12">
                                    <div class="header">
                                        <h4 class="card-icon-title"><span class="card-box-icon blue-card-icon-circle"><i class="icon-document-plus"></i></span> Lease Agreement</h4>
                                    </div>
                                    <div class="row">
                                        <div class="col-md-12">
                                            <div class="content">
                                            { agreement == null ? (
                                                <div>
                                                    <p class="category lease-margin">No agreement found.</p>
                                                    <img class="lease-image" src="/assets/img/Artboard@4x-8.png" />
                                                </div>
                                            ) : (
                                                agreement
                                            )}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-4 col-sm-12 col-xs-12">
                        <ActionCenterCard>
                            <ActionCenterEntry
                                title="Lease Signature"
                                description={leaseSigned}
                                buttonText={requestSigButtonText}
                                disabled={disableRequestSig}
                                buttonCallback={this.sendSignatureEmail}
                            />
                            <ActionCenterEntry
                                title="Tenant"
                                description={tenantName}
                                buttonText="Request Move Out"
                                buttonCallback={this.onRequestMoveOut.bind(this)}
                            />
                            <ActionCenterEntry
                                title="Lease Status"
                                description={leaseStatus}
                                buttonText="Request Renewal"
                                buttonCallback={this.onRequestRenewal.bind(this)}
                            />
                        </ActionCenterCard>
                    </div>
                    </div>
                    )}
                    {reportSalesActive == 'active' && (
                    <div class="row">
                        <div class="col-md-12">
                            <div class="card">
                                <div class="header col-md-6 col-sm-12 col-xs-12">
                                    <h4 class="title">Sales Reported</h4>
                                    <p class="category">Report your monthly sales.</p>
                                </div>
                                <SalesReportedList leaseId={0} />
                            </div>
                        </div>
                    </div>
                    )}
                </div>
            )
        }
    }
};



// WEBPACK FOOTER //
// app/components/Lease/LeaseTenantView.jsx